import DatasetTable, { datasetTableColumns } from "@/components/DatasetTable/DatasetTable";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import useTableStateUrl from "@/components/Table/hooks/useTableStateUrl";
import useAnalytics from "@/hooks/useAnalytics";
import { useImpactDatasets } from "@/hooks/useEcoInventDatasets";

export default function RootReferences() {
  const analytics = useAnalytics();

  const columns = [...datasetTableColumns.filter((x) => x.key !== "dataset_type")];

  const { pagination, filter, search, sort, onSearchFilterSortPaginate } = useTableStateUrl({
    columns,
    defaultPagination: { page: 1, pageSize: 20 },
  });

  const newSearch = { dataset_type: "root", ...search };

  const { data, isLoading, isFetching } = useImpactDatasets({
    pagination,
    filter,
    search: newSearch,
    sort,
  });

  analytics.track("Root References Overview Viewed");

  return (
    <div>
      <PageHeader
        title="Root impact references"
        description="Use our curated set of root impact references for standardized and reliable impact assessments."
      />
      <div>
        <DatasetTable
          columns={columns}
          totalRows={data?.total_count}
          onSearchFilterSortPaginate={onSearchFilterSortPaginate}
          pagination={pagination}
          data={data?.datasets}
          filter={filter}
          search={search}
          sort={sort}
          loading={isLoading || isFetching}
        />
      </div>
    </div>
  );
}
